import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'

Alpine.plugin(intersect)
Alpine.plugin(collapse)
window.Alpine = Alpine
window.Alpine.start()